// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServiceCategories_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /so/service_categories/lista.
 *
 * Returns the list of active service categories.
 */
import type { ServiceCategories_ListaRow } from './ServiceCategories_ListaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ServiceCategories_ListaResponseDados = ServiceCategories_ListaRow[];

export type ServiceCategories_ListaResponse = ApiResponse<ServiceCategories_ListaResponseDados>;

registerResponseContract('ServiceCategories_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_service_category_id:           { type: 'number',  required: true },
      so_service_category_name:         { type: 'string',  required: true },
      so_service_category_franchise_id: { type: 'number',  required: true },
      so_service_category_icon_svg:     { type: 'string',  required: false },
      so_service_category_active:       { type: 'number',  required: true },
      so_service_category_created_at:   { type: 'string',  required: false },
    },
  },
})
